<template>
    <v-dialog
            :value="!!value"
            :retain-focus="false"
            persistent
            max-width="800"
    >
        <v-form
                v-model="validForm"
                ref="form"
                @submit.prevent="submit"
        >
            <v-card
                    :loading="loading > 0"
                    :disabled="loading > 0"
            >
                <v-card-title class="grs-card-title px-0">
                    <span> {{ $t('user_form_title') }} </span>

                    <v-spacer></v-spacer>

                    <v-btn
                            text
                            small
                            icon
                            @click="$emit('close')"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0">
                    <v-text-field
                            v-model="value.full_name"
                            :label="$t('full_name')"
                            :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                            v-model="value.reseller_id"
                            :label="$t('reseller_id')"
                    ></v-text-field>
                    <v-text-field
                            v-model="value.manager_reseller_id"
                            :label="$t('manager_reseller_id')"
                    ></v-text-field>
                    <v-text-field
                            :disabled="value.id"
                            v-model="value.mobile"
                            :label="$t('mobile')"
                            :rules="[rules.required,rules.mobile]"
                    ></v-text-field>
                    <v-text-field
                            :disabled="value.email_verified_at"
                            v-model="value.email"
                            :label="$t('email')"
                    ></v-text-field>
                    <v-text-field
                            v-model="value.telegram_chat_id"
                            :label="$t('telegram_chat_id')"
                    ></v-text-field>
                    <v-text-field
                            v-if="!value.id"
                            v-model="value.password"
                            :label="$t('password')"
                            :rules="[rules.required,rules.password]"
                    ></v-text-field>
                    <v-checkbox
                            v-model="value.disabled_at"
                            :label="$t('disabled')"
                            type="checkbox"
                    ></v-checkbox>

                    <v-checkbox
                            v-model="value.role_id"
                            :label="$t('admin')"
                            type="checkbox"
                    ></v-checkbox>
                </v-card-text>

                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>

                    <v-btn
                            color="secondary"
                            text
                            class="px-4"
                            @click="$emit('close')"
                    >{{$t('cancel')}}</v-btn>

                    <v-btn
                            color="primary"
                            class="px-4"
                            type="submit"
                    >
                        {{$t('submit')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import { required, mobile, password } from '@/scripts/validationRules';
    import Service from "../services/UsersService";

    export default {
        props: {
            item : {
                required: true
            }
        },
        computed : {
        },
        data() {
            return {
                validForm: false,
                loading: 0,
                value : {...this.item},
                rules: {
                    required,
                    mobile,
                    password
                },

            }
        },
        created(){

        },
        methods: {

            async submit() {
                if(!this.validForm) {
                    return this.$refs.propertyBindingForm.validate();
                }

                try {
                    this.loading++;

                    if(this.value.role_id){
                        this.value.role_id = 1;
                    }else{
                        this.value.role_id = null;
                    }

                    if(this.value.disabled_at){
                        this.value.disabled_at = parseInt((new Date()).getTime() / 1000);
                    }else{
                        this.value.disabled_at = null;
                    }

                    let {
                        data
                    } = this.value.id ? await Service.update(this.value) : await Service.create(this.value);
                    this.$emit('submit', data);

                    this.$notify({
                        group: 'formGroup',
                        type: 'success',
                        title: data.message,
                    });

                } finally {
                    this.loading--;
                }

                this.$emit('close');


            }
        }
    }
</script>